import React from 'react';
import axios from 'axios';

class Upload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedImage: '',
      uploading: false,
      sucesso: false,
      erro: false,
    };

    this.onFileChange = this.onFileChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onFileChange(e) {
    const files = e.target.files;
    const reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (event) => {
      this.setState({
        selectedImage: event.target.result,
        sucesso: false,
        erro: false
      });
    };
  }

  async onSubmit() {
    this.setState({ uploading: true });

    try {
      const res = await axios.post("https://refugiadonacozinha.com.br/add_recette.php", {
        image: this.state.selectedImage,
        titre: this.props.titre,
        categorie: this.props.categorie,
        ingredients: this.props.ingredients,
        etapes: this.props.etapes,
        infos: this.props.infos,
        sinopse: this.props.sinopse,
        vegan: this.props.vegan
      });

      if (res.data.codigo === 200) {
        this.setState({ sucesso: true, uploading: false });
      } else {
        this.setState({ erro: true, uploading: false });
      }


    } catch (err) {
      console.error("Erro ao enviar:", err);
      this.setState({ erro: true, uploading: false });
    }
  }

  render() {
    return (
      <div>
        <div className="form-group mb-3">
          <label>Selecione uma imagem</label>
          <input type="file" className="form-control" onChange={this.onFileChange} />
        </div>

        {this.state.selectedImage && (
          <div style={{ marginBottom: '10px' }}>
            <img src={this.state.selectedImage} alt="preview" style={{ width: '150px', borderRadius: '8px' }} />
          </div>
        )}

        <button
          type="submit"
          className="primary-button"
          onClick={this.onSubmit}
          disabled={this.state.uploading}
        >
          {this.state.uploading ? 'Enviando...' : 'Enviar'}
        </button>

        {this.state.sucesso && <p style={{ color: 'green' }}>✅ Receita enviada com sucesso!</p>}
        {this.state.erro && <p style={{ color: 'red' }}>❌ Erro ao enviar a receita.</p>}
      </div>
    );
  }
}

export default Upload;
